import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homenine-events',
  templateUrl: './homenine-events.component.html',
  styleUrls: ['./homenine-events.component.scss']
})
export class HomenineEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
